import { Helmet } from "react-helmet";

export default function SectionFour({ openModal }: any) {
  return (
    <div className="w-full relative overflow-hidden font-aldrich">
      <Helmet>
        <title>Transform Your Practice | DUMOSH Growth</title>
        <meta
          name="description"
          content="Achieve 300% growth in 3 months with DUMOSH. Packed appointment schedules, zero missed opportunities, and consistent practice growth."
        />
        <meta
          name="keywords"
          content="practice growth, patient appointments, medical marketing, clinic expansion"
        />
        <meta
          property="og:title"
          content="Transform Your Practice | DUMOSH Growth"
        />
        <meta
          property="og:description"
          content="We guarantee 300% growth in 3 months. Discover how DUMOSH can transform your practice today."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="max-w-2xl md:max-w-full lg:mx-[2rem]  flex flex-col space-y-8">
        <div className="bg-black text-white flex flex-col items-center text-center ">
          {/* Heading Section */}
          <div className="w-full p-2 sm:p-4">
            <h2 className="text-lg md:text-xl lg:text-2xl xl:text-4xl text-start">
              Transform your practice today
            </h2>
            <p className="text-left text-lg md:text-xl lg:text-2xl xl:text-4xl">
              What you get:
            </p>
          </div>

          {/* Descritpion Section */}
          <div className="m-0 w-full p-2 sm:p-4">
            <p className="text-base md:text-lg lg:text-xl xl:text-3xl text-start w-full text-[#FF2020] mb-2">
              We take only limited number of clients each month to deliver
              unmatched results.
            </p>
            <p className="text-base md:text-lg lg:text-xl xl:text-3xl text-start w-full">
              While you focus on treating patients,{" "}
              <b className="text-base md:text-lg lg:text-xl xl:text-3xl text-left text-white font-bold font-impact">
                DUMOSH
                <span className="text-base md:text-lg lg:text-xl xl:text-3xl text-left  text-[#FF3E3E] ">
                  .
                </span>
              </b>
              {""} will handle your growth with:
            </p>
          </div>

          {/* Listed Materials */}
          <div className="m-0 flex flex-col w-full justify- items-start p-4 sm:p-6 space-y-4 md:space-y-8">
            <p className="text-base md:text-lg lg:text-xl xl:text-3xl text-left text-white">
              <span className="text-base md:text-lg lg:text-xl xl:text-3xl text-left  text-[#FF3E3E] pr-1 ">
                •
              </span>
              Packed Appointment Schedules
            </p>
            <p className="text-base md:text-lg lg:text-xl xl:text-3xl text-left text-white">
              <span className="text-base md:text-lg lg:text-xl xl:text-3xl text-left  text-[#FF3E3E] pr-1 ">
                •
              </span>
              Zero Missed Patient Opportunities
            </p>
            <p className="text-base md:text-lg lg:text-xl xl:text-3xl text-left text-white">
              <span className="text-base md:text-lg lg:text-xl xl:text-3xl text-left  text-[#FF3E3E] pr-1 ">
                •
              </span>
              Consistent Practice Growth
            </p>
          </div>

          <div className="w-full flex items-center justify-end mx-2 my-4">
            <button
              onClick={openModal}
              className="bg-red-600 text-white m-0 py-2 px-[4px] md:px-14 text-[12px] md:text-xl lg:text-2xl xl:text-3xl transform transition-transform duration-300 hover:scale-105 active:scale-95 hover:bg-red-700 whitespace-nowrap ml-[2px]"
            >
              <p>With a Guarantee of 300% growth in just 3 months</p>
            </button>
            <span className="bg-red-600 h-[2px] w-full md:w-[10%] xl:w-[20%]"></span>
          </div>
        </div>
      </div>
    </div>
  );
}
